module.exports = __webpack_public_path__ + "img/products-2.c6c0852e.png";